import { defineComponent, h } from 'vue';
import { QBtn, QDialog, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'dynamic-tab-content-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QBtn,
        QDialog,
        QTooltip,
        ControlPicker,
    },
    data() {
        return {
            tab_state: {
                index: 0,
            },
            /** When set (e.g. bound tab model), repeats Controls per model entry like runtime stack */
            model: null,
        };
    },
    computed: {
        direction() {
            if (this.controlData?.Direction)
                return this.controlData.Direction;
            return 'Normal';
        },
    },
    methods: {
        generateItems(h, controlData, items, model, index, parentType) {
            if (!controlData?.Controls)
                return;
            const tempItems = [];
            for (let i = 0; i < controlData.Controls.length; i++) {
                const c = controlData.Controls[i];
                if (typeof c !== 'object')
                    continue;

                const DynamicControl = utils.getDesignerComponent(c, null);

                if (!c.$objectId) c.$objectId = utils.generateUUID();

                let id = `${this.master_key}_${c.$objectId}`;
                if (index) id = `${index}_${id}`;

                tempItems.push(
                    <DynamicControl
                        key={id}
                        type={c.ControlType}
                        name={c.ControlData ? c.ControlData.Name : ''}
                        root={this.root}
                        designmodel={c}
                        parentType={parentType}
                        controlData={c.ControlData}
                        controlURL={c.ControlURL}
                        sourceData={model}
                        sourceIndex={i}
                    />
                );
            }
            if (this.direction === 'Reversed')
                tempItems.reverse();
            items.push(...tempItems);
        },
        generateItemsFromModel(h, items, controlData, items_id, parentType) {
            if (this.model && typeof this.model === 'object') {
                if (Array.isArray(this.model)) {
                    for (let i = 0; i < this.model.length; i++) {
                        const item = this.model[i];
                        const item_index = `${i}_${items_id}`;
                        this.generateItems(h, controlData, items, item, item_index, parentType);
                    }
                }
                else {
                    Object.keys(this.model).forEach((key) => {
                        const item = this.model[key];
                        const item_index = `${key}_${items_id}`;
                        this.generateItems(h, controlData, items, item, item_index, parentType);
                    });
                }
            }
            else if (controlData.Controls)
                this.generateItems(h, controlData, items, null, items_id, parentType);
        },
    },
    props: {
        //name: { type: String, default: '' },
        //root: { type: Object, default: null },
        //designmodel: { type: Object, default: null },
        //parentType: { type: String, default: '' },
        //controlData: { type: Object, default: () => ({}) },
    },
    render() {
        if (!this.controlData)
            return null;

        const controlData = this.controlData;
        const items = [];
        this.generateItemsFromModel(h, items, controlData, '_0', 'VerticalStack');

        if (this.selected$) {
            items.push(
                <QBtn
                    key="add-body"
                    size="sm"
                    flat
                    icon="mdi-plus-circle"
                    color="blue-8"
                    style={{ zIndex: 992 }}
                    onClick={(e) => this.addControl(e, 'body')}>
                    <QTooltip>Add control to body</QTooltip>
                </QBtn>
            );
        }

        const style = {
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            minWidth: '25px',
            alignItems: 'flex-start',
            ...utils.getSize(controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(controlData.StyleHints),
        };

        return (
            <div
                class={{
                    'c-DynamicTabContent': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    'designer-container': true,
                    selected: this.selected$,
                }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />

                {items}

                {this.generatePicker(h)}
            </div>
        );
    },
});
